import { JsonProperty } from "../../../models/utilities/json-property";
import { PendingReason } from '../../../models/ordering/enums/pending-reason';

export class EngineeringReviewList {

    public id: number = 0;

    public orderId: string = '';

    public description: string = '';

    public reason: EngineeringReviewReason | null = null;

    public pendingReason: PendingReason = PendingReason.None;

    @JsonProperty({ toType: 'date' })
    public cutoffDate : Date|undefined = undefined;
}

export enum EngineeringReviewReason {
    warnings = 1,
    hlTrack = 2,
    vlTrack = 4,
    frlTrack = 8,
    springs3Inch = 16, // 3 3/4 inch
    springs6Inch = 32,
    springsMultiShaft = 64,
    notes = 128,
    blackFlag = 256
}

export const EngineeringReviewReasonMetadata = {
    '1': {
        display: 'Warnings',
        value: 1
    },
    '2': {
        display: 'Track - HL',
        value: 2
    },
    '4': {
        display: 'Track - VL',
        value: 4
    },
    '8': {
        display: 'Track - FRL',
        value: 8
    },
    '16': {
        display: 'Springs - 3 3/4"',
        value: 16
    },
    '32': {
        display: 'Springs - 6"',
        value: 32
    },
    '64': {
        display: 'Springs - Multi-Shaft',
        value: 64
    },
    '128': {
        display: 'Notes',
        value: 128
    },
    '256': {
        display: 'Black Flag',
        value: 256
    }
}